import { useBookmarkStore } from './BookmarkStore.js';
export const useBookmarks = () => {
    const [bookmarks, selectedBookmark, recentWallets] = useBookmarkStore((store) => [store.bookmarks, store.selectedBookmark, store.recentWallets]);
    return {
        bookmarks,
        selectedBookmark,
        recentWallets,
    };
};
//# sourceMappingURL=useBookmarks.js.map